import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function GiftIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 12 12" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.5203 0.813134C8.71556 1.0084 8.71556 1.32498 8.5203 1.52024L7.37385 2.66669H10.8334C11.1096 2.66669 11.3334 2.89054 11.3334 3.16669V5.50002C11.3334 5.77616 11.1096 6.00002 10.8334 6.00002H10.6667V9.50002C10.6667 10.5126 9.84596 11.3334 8.83341 11.3334H3.16675C2.15423 11.3334 1.33341 10.5126 1.33341 9.50002V6.00002H1.16675C0.890606 6.00002 0.666748 5.77616 0.666748 5.50002V3.16669C0.666748 2.89054 0.890606 2.66669 1.16675 2.66669H4.62631L3.47986 1.52024C3.2846 1.32498 3.2846 1.0084 3.47986 0.813134C3.67512 0.617871 3.99171 0.617871 4.18697 0.813134L6.00008 2.62625L7.81319 0.813134C8.00846 0.617871 8.32504 0.617871 8.5203 0.813134ZM6.50008 6.00002H9.66675V9.50002C9.66675 9.96028 9.29367 10.3334 8.83341 10.3334H6.50008V6.00002ZM5.50008 6.00002H2.33341V9.50002C2.33341 9.96027 2.70651 10.3334 3.16675 10.3334H5.50008V6.00002ZM10.3334 5.00002H10.1667H1.83341H1.66675V3.66669H10.3334V5.00002Z"
        fill="#475467"
      />
    </svg>
  );
};
